import React, { Component } from 'react'
import style from './style.css'

import { Col, Row } from '../../atoms/Grid'
import If from '../../atoms/If'
import Avatar from '../../atoms/Avatar'
import Font from '../../atoms/Font'

import T from '../../../SPRINTA/translate/T'

class AthletesList extends Component {

    render() {
        let items = this.props.data
        return (
            <div className={style.container}>
                <div className={`${style.title}`}>
                    <Font size="25" color='#666' weight="700" dangerouslySetInnerHTML={{__html: this.props.titleCategory}}></Font>
                    <Font size="25" color="#FF5500" weight="700">&nbsp;({this.props.titleCategoryNumber})</Font><br />
                    <Font heading="5" weight="200" dangerouslySetInnerHTML={{__html: this.props.titleDescription}}></Font>
                </div>
                <Col size="12" className={`${style.categories}`}>
                    <Col size={1}></Col>
                    <Col size={5} className={`${style.name}`}>
                        <Row>
                            <p>{T.text('name')}</p>
                        </Row>
                    </Col>
                    <Col size={6} className={`${style.team}`}>
                        <Row>
                            <p>{T.text('team')}</p>
                        </Row>
                    </Col>
                </Col>
                {items.map(item => 
                    <Col size="12" key={`${item.inscription_id}${item.user_name}`} className={`${style.list}`}>
                        <Col size={1}>
                            <Avatar size={30} img={item.user_avatar_path}/>
                        </Col>
                        <Col size={5}>
                            <p>{item.user_name}</p>
                        </Col>
                        <Col size={5}>
                            <Row>
                                <p>{item.user_team}</p>
                            </Row>
                        </Col>
                        <Col size={1}>
                            <If test={item.confirmed === "1"}>
                                <div className={`${style.checked}`}>&#10003;</div>
                            </If>
                        </Col>
                    </Col>
                )}
            </div>
        )
    }
}
  
export default AthletesList;


// WEBPACK FOOTER //
// ./src/components/molecules/AthletesList/index.js